type MonthOption = { key: string; value: string };

export function getAvailableMonths(
  allMonths: MonthOption[],
  selectedYear: string,
  startYear: string,
  startMonth: string,
  endYear: string,
  endMonth: string
): MonthOption[] {
  const isStartYear = selectedYear === startYear;
  const isEndYear = selectedYear === endYear;

  if (isStartYear && isEndYear) {
    return allMonths.filter((m) => m.key >= startMonth && m.key <= endMonth);
  }
  if (isStartYear) {
    return allMonths.filter((m) => m.key >= startMonth);
  }
  if (isEndYear) {
    return allMonths.filter((m) => m.key <= endMonth);
  }
  return allMonths;
}
